import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../../../../actions/notificationAction';
import { t13s } from '../../../../translationKeys';
import { deleteInvoiceDiscountService } from '../services';

export const useDeleteInvoiceDiscount = () => {
  const dispatch = useDispatch();
  const {
    isLoading: deleteInvoiceDiscountLoading,
    mutate: deleteInvoiceDiscount,
  } = useMutation(
    ({ sourceId, sourceType }) => {
      return deleteInvoiceDiscountService({ sourceId, sourceType });
    },
    {
      onSuccess: (_res, data) => {
        const { onSuccessCallback = () => undefined } = data;
        dispatch(
          enqueueSnackbar(t13s.NOTIFICATION.DISCOUNT_DELETED, {
            variant: 'success',
          })
        );
        onSuccessCallback();
      },
      onError: () => {
        dispatch(
          enqueueSnackbar('error al eliminar descuento', {
            variant: 'error',
          })
        );
      },
    }
  );

  return {
    deleteInvoiceDiscountLoading,
    deleteInvoiceDiscount,
  };
};

export default useDeleteInvoiceDiscount;
